import HotLeisureTips from './HotLeisureTips'


export default HotLeisureTips
